import type { ReactNode } from 'react';
import { type VariantProps, tv } from 'tailwind-variants';

import type { CommonProps } from '../../types';
import { SpaceCard } from './space-card';

export interface SpaceListProps
    extends CommonProps,
        VariantProps<typeof SpaceListStyles> {
    children?: ReactNode;
}

export const SpaceListStyles = tv({
    slots: {
        root: 'self-start flex flex-col xs:grid xs:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-12 mb-7 md:col-span-2 lg:col-span-3',
    },
});

const SpaceList = ({ children, ...props }: SpaceListProps) => {
    const { root } = SpaceListStyles();

    return (
        <div className={root()} role="region" {...props}>
            {children}
        </div>
    );
};

SpaceList.Card = SpaceCard;

export { SpaceList };
